<div style="margin-left: 4%; margin-right: 4%">
  <div style="margin-top: 1.875rem; display: inline-block">
    <div style="display: inline-block; margin-right: 1.75rem">
      <span class="chargingProjectHeader">Charging Project Setup - Summary</span>
    </div>
    <div
      style="cursor: pointer; display: none"
      (click)="editSummary()"
      [class.disabledSummary]="editSummaryOn"
    >
      <img src="assets/edit-pencil.svg" />
      <div
        style="
          text-align: center;
          display: inline-block;
          border-bottom: 0.125rem solid;
          width: 2.875rem;
        "
        [class.disabledSummaryUnderline]="editSummaryOn"
      >
        <span>EDIT</span>
      </div>
    </div>
    <div
      style="display: inline-block; padding-left: 1rem; padding-right: 1rem"
      [class.hideEditButtons]="!editSummaryOn"
    >
      <button
        class="confirmButton"
        style="width: 8.125rem; margin-right: 0"
        (click)="saveSummaryChanges()"
      >
        <span class="confirmText">SAVE CHANGES</span>
      </button>
    </div>
    <div style="display: inline-block" [class.hideEditButtons]="!editSummaryOn">
      <div
        class="exitButton"
        style="width: 8.125rem; height: 2.05rem; padding-top: 0.5rem"
        (click)="cancelSummaryChanges()"
      >
        <span class="exitText">CANCEL</span>
      </div>
    </div>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div style="display: inline-block; margin-top: 1.563rem; margin-left: 1.563rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <input [(ngModel)]="fundingProjectID" placeholder="Funding Project ID" matInput />
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <mat-select [compareWith]="compareState" [(value)]="state" placeholder="State">
        @for (option of stateOptions; track option) {
          <mat-option style="color: #696969" [value]="option"
            ><span>{{ option.state }}</span></mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem">
    <mat-form-field class="fundingFields" style="pointer-events: none">
      <mat-select [(value)]="businessUnit" placeholder="Business Unit">
        @for (option of businessUnitOptions; track option) {
          <mat-option style="color: #696969" [value]="option"
            ><span>{{ option }}</span></mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div
    style="
      display: inline-block;
      margin-top: 0.313rem;
      margin-left: 0.313rem;
      float: right;
      margin-right: 1.875rem;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      padding-top: 1.25rem;
    "
    [class.editBackground]="editSummaryOn"
  >
    <mat-form-field
      style="width: 12.5rem; pointer-events: none; background-color: white"
      [class.editEnabled]="editSummaryOn"
    >
      <mat-label>Estimated Start Date</mat-label>
      <input
        matInput
        [matDatepicker]="startDatePicker"
        [(ngModel)]="estimatedStartDate"
        style="color: #696969"
      />
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div
    style="display: inline-block; margin-left: 0.3rem; padding: 1.25rem"
    [class.editBackground]="editSummaryOn"
  >
    <mat-form-field
      class="fundingFields"
      style="pointer-events: none; width: 31.25rem; background-color: white"
      [class.editEnabled]="editSummaryOn"
    >
      <input [(ngModel)]="projectName" placeholder="Project Name" matInput />
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-top: 1.563rem; margin-left: 1.563rem">
    <mat-form-field class="fundingFields" style="pointer-events: none; width: 18.75rem">
      <input [(ngModel)]="projectManager" placeholder="Project Manager" matInput />
    </mat-form-field>
  </div>
  <div
    style="
      display: inline-block;
      margin-left: 0.313rem;
      float: right;
      margin-right: 1.875rem;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      padding-top: 1.563rem;
      padding-bottom: 1.25rem;
    "
    [class.editBackground]="editSummaryOn"
  >
    <mat-form-field
      style="width: 12.5rem; pointer-events: none; background-color: white"
      [class.editEnabled]="editSummaryOn"
    >
      <mat-label>Estimated In Service Date</mat-label>
      <input
        matInput
        [matDatepicker]="inServiceDatePicker"
        [(ngModel)]="estimatedInServiceDate"
        style="color: #696969"
      />
      <mat-datepicker-toggle matSuffix [for]="inServiceDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #inServiceDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div style="display: inline-block; margin-top: 0.5rem; margin-left: 1.563rem">
    <mat-form-field class="fundingFields" style="pointer-events: none; width: 5.875rem">
      <input [(ngModel)]="operatingUnit.OPERATING_UNIT" placeholder="Operating Unit" matInput />
    </mat-form-field>
  </div>
  <div
    style="display: inline-block; margin-left: 0.313rem; padding: 1.25rem"
    [class.editBackground]="editSummaryOn"
  >
    <mat-form-field
      class="fundingFields"
      style="pointer-events: none; width: 18.75rem; background-color: white"
      [class.editEnabled]="editSummaryOn"
    >
      <input
        [(ngModel)]="powerPlanProjectType.description"
        placeholder="PowerPlan Project Type"
        matInput
      />
    </mat-form-field>
  </div>
  <div
    style="display: inline-block; margin-left: 4.313rem; padding: 1.25rem"
    [class.editBackground]="editSummaryOn"
  >
    <mat-form-field
      class="fundingFields"
      style="pointer-events: none; width: 18.75rem; background-color: white"
      [class.editEnabled]="editSummaryOn"
    >
      <input [(ngModel)]="majorLocation.major_location" placeholder="Major Location" matInput />
    </mat-form-field>
  </div>
  <div
    style="
      display: inline-block;
      margin-top: 0.5rem;
      margin-left: 1.563rem;
      float: right;
      margin-right: 3.125rem;
    "
  >
    <mat-form-field style="width: 12.5rem; pointer-events: none">
      <mat-label>Estimated Completion Date</mat-label>
      <input
        matInput
        [matDatepicker]="completionDatePicker"
        [(ngModel)]="estimatedCompletionDate"
        style="color: #696969"
      />
      <mat-datepicker-toggle matSuffix [for]="completionDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #completionDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div
    style="display: inline-block; margin-top: 0.313rem; margin-left: 0.313rem; padding: 1.25rem"
    [class.editBackground]="editSummaryOn"
  >
    <mat-form-field
      class="fundingFields"
      style="pointer-events: none; width: 18.75rem; background-color: white"
      [class.editEnabled]="editSummaryOn"
    >
      <input [(ngModel)]="projectChargeIndicator" placeholder="Project Charge Indicator" matInput />
    </mat-form-field>
  </div>
  <div
    style="display: inline-block; margin-top: 0.313rem; margin-left: 0.313rem; padding: 1.25rem"
    [class.editBackground]="editSummaryOn"
  >
    <mat-form-field
      class="fundingFields"
      style="pointer-events: none; width: 7.813rem; background-color: white"
      [class.editEnabled]="editSummaryOn"
    >
      <input [(ngModel)]="respCenter.DEPARTMENT_ID" placeholder="Resp. Center" matInput />
    </mat-form-field>
  </div>
  <div
    style="display: inline-block; margin-top: 0.313rem; margin-left: 2.313rem; padding: 1.25rem"
    [class.editBackground]="editSummaryOn"
  >
    <mat-form-field
      class="fundingFields"
      style="pointer-events: none; width: 18.75rem; background-color: white"
      [class.editEnabled]="editSummaryOn"
    >
      <input [(ngModel)]="contractAdmin.full_name" placeholder="Contract Admin" matInput />
    </mat-form-field>
  </div>
  <div
    style="
      display: inline-block;
      margin-top: 0.5rem;
      margin-left: 1.563rem;
      float: right;
      margin-right: 3.125rem;
    "
  >
    <mat-form-field style="width: 12.5rem; pointer-events: none">
      <mat-label>Cost Estimate</mat-label>
      <input matInput [(ngModel)]="costEstimate" style="color: #696969" />
    </mat-form-field>
  </div>
</div>
<div style="margin-left: 5.2%; display: flex">
  <div style="display: inline-block">
    <div>
      <span style="font-size: 0.75rem; color: #676767">Asset Location</span>
    </div>
    <textarea
      [(ngModel)]="assetLocation.long_description"
      class="textBox"
      style="width: 27.125rem; height: 9.583rem"
      [class.editEnabledBorder]="editSummaryOn"
      [class.editEnabled]="editSummaryOn"
    ></textarea>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem; margin-top: 1.5rem">
    <div>
      <span style="font-size: 0.75rem; color: #676767">Activities</span>
    </div>
    <div style="width: 21.25rem">
      <span style="color: #696969">
        @if (firstStandardActivity) {
          <span>
            <span>Standard: {{ firstStandardActivity }}</span>
          </span>
        }
        @if (standardActivities.length > 0) {
          <span>
            @for (activity of standardActivities; track activity; let i = $index) {
              <span>, {{ activity }}</span>
            }
          </span>
        }
      </span>
    </div>
    <div style="width: 21.25rem">
      <span style="color: #696969">
        @if (firstActivity) {
          <span>
            <span>Non-Standard: {{ firstActivity.activityID }}</span>
          </span>
        }
        @if (activities.length > 0) {
          <span>
            @for (activity of activities; track activity; let i = $index) {
              <span>, {{ activities[i].activityID }}</span>
            }
          </span>
        }
      </span>
    </div>
  </div>
</div>
<div style="margin-left: 5.2%; margin-top: 2.188rem">
  <div>
    <span style="font-size: 0.875rem; color: #696969">Project Long Description</span>
  </div>
  <textarea
    [(ngModel)]="projectLongDescription"
    class="textBox"
    style="width: 51.875rem; height: 35.313rem"
  ></textarea>
</div>
<div style="margin-left: 5.2%; margin-top: 2.188rem">
  <div>
    <span style="font-size: 0.875rem; color: #676767">Problem Statement</span>
  </div>
  <textarea
    [(ngModel)]="problemStatement"
    class="textBox"
    style="width: 51.875rem; height: 6.25rem"
  ></textarea>
</div>
<div style="margin-left: 5.2%; margin-top: 2.188rem">
  <div>
    <span style="font-size: 0.875rem; color: #676767">Proposed Objective</span>
  </div>
  <textarea
    [(ngModel)]="proposedObjective"
    class="textBox"
    style="width: 51.875rem; height: 6.25rem"
  ></textarea>
</div>
<div style="margin-left: 5.2%; margin-top: 2.188rem">
  <div>
    <span style="font-size: 0.875rem; color: #676767">Notes</span>
  </div>
  <textarea
    [(ngModel)]="notes"
    class="textBox"
    style="width: 51.875rem; height: 6.25rem"
    [class.editEnabledBorder]="editSummaryOn"
    [class.editEnabled]="editSummaryOn"
  ></textarea>
</div>
<div style="margin-bottom: 4.375rem; margin-top: 3.75rem">
  <div class="startOverButton" (click)="goToPreviousPage()">
    <span style="font-size: 0.875rem; color: #00789e">PREVIOUS PAGE</span>
  </div>
  <div style="display: inline-block">
    <div class="exitButton" (click)="exitPage()">
      <span class="exitText">EXIT</span>
    </div>
  </div>
  <div style="display: inline-block; float: right">
    <div style="display: inline-block">
      <button
        class="confirmButton"
        [disabled]="submittingProject"
        [class.buttonDisabled]="submittingProject"
        (click)="submitChargingProject()"
      >
        @if (!submittingProject) {
          <span class="confirmText">FINISH</span>
        }
        @if (submittingProject) {
          <div class="dot-spin" style="margin: auto"></div>
        }
      </button>
    </div>
  </div>
</div>
